import { render, staticRenderFns } from "./common-header.vue?vue&type=template&id=40e85288&scoped=true&lang=pug&"
import script from "./common-header.vue?vue&type=script&lang=js&"
export * from "./common-header.vue?vue&type=script&lang=js&"
import style0 from "./common-header.vue?vue&type=style&index=0&id=40e85288&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e85288",
  null
  
)

export default component.exports